import classNames from 'classnames';
import React from 'react';
import type { GroupBase } from 'react-select';
import { components } from 'react-select';
import alertIcon from '../../icons/non-prefilled/16x16/alert.svg';
import SVGIcon from '../SVGIcon';
import type { OptionTypeBase, SelectProps } from '../Select';
import Select from '../Select';
import Tooltip from '../Tooltip';
import styles from './SelectControl.module.scss';

export type SelectControlProps<
  Option extends OptionTypeBase,
  IsMulti extends boolean = boolean,
  IsClearable extends boolean = boolean,
> = Omit<
  SelectProps<Option, IsMulti, true, GroupBase<Option>, IsClearable>,
  'creatable'
> & {
  isMulti?: IsMulti;
  label?: React.ReactNode;
  error?: string;
  disabled?: boolean;
  inlineError?: boolean;
};

const SelectControl = <
  Option extends OptionTypeBase,
  IsMulti extends boolean = false,
  IsClearable extends boolean = false,
>({
  label,
  error,
  disabled,
  inlineError,
  ...inputProps
}: SelectControlProps<Option, IsMulti, IsClearable>) => (
  <label>
    {!!label && <div className={styles.label}>{label}</div>}
    <div className={styles.inputContainer}>
      <Select<Option, IsMulti, true, GroupBase<Option>, IsClearable>
        className={classNames(styles.select, { [styles.error]: error })}
        blurInputOnSelect
        simpleValue
        isDisabled={disabled}
        components={{
          // eslint-disable-next-line react/no-unstable-nested-components
          IndicatorsContainer: (props) => (
            <div className={styles.indicatorsContainer}>
              {inlineError && error && (
                <Tooltip
                  display="block"
                  placement="top"
                  popOverPortal={document.body}
                  tooltip={error}
                  trigger="hover"
                  danger
                  modifiers={[{ name: 'offset', options: { offset: [0, 9] } }]}
                >
                  <SVGIcon className={styles.errorIcon}>{alertIcon}</SVGIcon>
                </Tooltip>
              )}
              <components.IndicatorsContainer {...props} />
            </div>
          ),
        }}
        {...inputProps}
      />
    </div>
  </label>
);

export default SelectControl;
